import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { storage } from 'config/firebase';
import {
    downloadCsvTemplateFailure,
    downloadCsvTemplateSuccess
} from 'store/actions/Managers';
import { DOWNLOAD_CSV_TEMPLATE } from 'store/actions/types';
import { getDownloadURL, ref } from 'firebase/storage';

function* downloadTemplateSaga({ payload }) {
    const { collection } = payload;
    try {
        const storageRef = ref(storage, `templates/${collection}-template.csv`);
        const url = yield call(getDownloadURL, storageRef);

        yield put(downloadCsvTemplateSuccess(url));
    } catch (error) {
        yield put(downloadCsvTemplateFailure(error.message));
    }
}

export function* downloadCsvTemplate() {
    yield takeLatest(DOWNLOAD_CSV_TEMPLATE, downloadTemplateSaga);
}

export default function* rootSaga() {
    yield all([fork(downloadCsvTemplate)]);
}
